import { Box, Stack, Typography } from "@mui/material";
import { useMemo } from "react";

const EXPBlock = ({
  title,
  value,
  maxValue,
}: {
  title?: string;
  value: number;
  maxValue: number;
}) => {
  const percentage = useMemo(() => {
    const percentage = (value / maxValue) * 100;
    return percentage > 100 ? 100 : percentage;
  }, [value, maxValue]);
  return (
    <Stack
      position={"relative"}
      borderRadius={"8px"}
      bgcolor={"primary.dark"}
      width={"100%"}
      height={"28px"}
      border={"1px solid"}
      borderColor={"primary.darkBorder"}
    >
      <Box
        width={`${percentage}%`}
        borderRadius={percentage <= 98 ? "7px 0px 0px 7px" : "7px"}
        height={"100%"}
        bgcolor={"primary.main"}
        sx={{
          background: "linear-gradient(to top right, #0080DB, #00D7FF)",
        }}
      />
      <Stack
        justifyContent={"space-between"}
        direction={"row"}
        alignItems={"center"}
        px={1}
        position={"absolute"}
        width={"100%"}
      >
        <Typography color="white"> {title || "\u00A0"}</Typography>
        <Typography color="white" fontSize={"14px"}>
          {value} / {maxValue}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default EXPBlock;
